import { FullCommunityQuestion } from 'model';
import { PostTypeViewProps } from './types.js';
import { PostTitle } from '../PostTitle.js';
import { PostContentsSummary } from '../PostContentsSummary.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';

// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import { PostHeader } from '../PostHeader.js';
import { filterInlineImages } from '../../util/filterInlineImages.js';

export function CommunityQuestionView({
	post,
	detail,
	preview,
	testId,
	expanded
}: PostTypeViewProps<FullCommunityQuestion>) {
	return (
		<>
			<PostHeader post={post} />
			<PostTitle postId={post._id}>{post.title}</PostTitle>
			{!preview && (
				<div className={postStyles.postBody} data-testid={testId}>
					{detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
					<PostContentsSummary post={post} allowExpand={detail} expanded={expanded} />
					<LinkPreviewComponent linkPreview={post.linkPreview} />
					{!detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
				</div>
			)}
		</>
	);
}
